const PROVIDERS = {
	100 : 'МТС',
	101 : 'Velcom',
	102 : 'Life'
};

export default PROVIDERS;


// WEBPACK FOOTER //
// ./src/app/constants/providers.js